import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { DataTable } from 'web-ui-components/lib/molecules/tables';
import { Button } from 'web-ui-components/lib/atoms/buttons';
import { getAllArchivedMandates, getArchiveSortOrder } from '../../../states/managePayments/selectors';
import { formatFrom, amountFormater, formatTo, inActiveListingColumns, showFileUploadIcon } from './ColumnFormater';
import { sortOrders, MANDATE_PAGE_SIZE } from '../../../config';
import { getSortedResults } from './ActivePaymentListing';

import withContent from '../../../containers/withContent';
import content, { contentPropTypes } from './PaymentListing.content';
import ViewArchiveModal from '../ViewPaymentContainer/ViewArchiveModal';
import { setArchiveSortOrder, setArchiveViewMandate } from '../../../states/managePayments/actions';

const mapState = (state) => ({
	archivedMandates: getAllArchivedMandates(state),
	sortByColumn: getArchiveSortOrder(state),
});
const mapDispatch = (dispatch) => ({
	handleArchiveView: (mandateToView) => dispatch(setArchiveViewMandate(mandateToView)),
	setArchiveSortOrder: (order) => dispatch(setArchiveSortOrder(order)),
});
const getFormattedResult = (mandate, handleView) => ({
	...mandate,
	from: formatFrom(mandate),
	options: (
		<Button id={`view-button-${mandate.id}`} width="flush" size="xs" onClick={() => handleView(mandate)}>
			View
		</Button>
	),
	to: formatTo(mandate),
	formatedAmount: amountFormater(mandate),
	paymentUploadIcon: showFileUploadIcon(mandate.isFileUploadBatch),
});

class ArchivedPaymentListing extends Component {
	constructor(props) {
		super(props);

		this.state = { showViewModal: false };

		this.handleSortOrder = this.handleSortOrder.bind(this);
		this.getResultsToDisplay = this.getResultsToDisplay.bind(this);
		this.showViewModal = this.showViewModal.bind(this);
		this.hideViewModal = this.hideViewModal.bind(this);
	}
	getResultsToDisplay() {
		const {
			archivedMandates,
			sortByColumn: { id, sortDirection },
			mandateArchivePage,
			mandateArchivePageTotal,
		} = this.props;

		const sortedResult = getSortedResults(archivedMandates, id, sortDirection);
		const formattedResult = sortedResult.map((mandate) => ({
			...getFormattedResult(mandate, this.showViewModal),
		}));

		if (mandateArchivePageTotal > 1) {
			return formattedResult.slice(
				(mandateArchivePage - 1) * MANDATE_PAGE_SIZE,
				mandateArchivePage * MANDATE_PAGE_SIZE
			);
		}
		return formattedResult;
	}
	handleSortOrder(column) {
		const sortByColumn = {
			...column,
			sortDirection: sortOrders[column.sortDirection],
		};
		this.props.setArchiveSortOrder(sortByColumn);
		this.props.persistSortOrder(sortByColumn, false);
		this.setState({
			showViewModal: false,
		});
	}
	showViewModal(mandate) {
		this.props.handleArchiveView(mandate);
		this.setState({
			showViewModal: true,
		});
	}
	hideViewModal() {
		this.setState({
			showViewModal: false,
		});
	}
	render() {
		const {
			hasError,
			hasApiCallInProgress,
			archivedMandates,
			content: { footerArchiveListingMsg },
			renderRetryComponent,
			sortByColumn,
			mandateArchivePage,
			mandateArchivePageTotal,
		} = this.props;
		const { showViewModal } = this.state;
		const results = hasError || hasApiCallInProgress ? [] : this.getResultsToDisplay(archivedMandates);
		const showFooter = !!results.length;
		const columns = inActiveListingColumns(sortByColumn);
		const isPaginated = mandateArchivePageTotal > 1;
		const isLastPage = !isPaginated || (isPaginated && mandateArchivePage === mandateArchivePageTotal);

		return (
			<div id="scheduled-payment__archived">
				<DataTable
					breakpointSnap="1280"
					isBranded
					layout="transactions"
					columns={columns}
					data={results}
					keyPath={['id']}
					onHeaderCellClick={this.handleSortOrder}
				/>
				{hasError && renderRetryComponent()}
				{showFooter && isLastPage && (
					<div id="footer-msg" className="u-padding-2 u-text-align-center">
						{footerArchiveListingMsg}
					</div>
				)}
				{showViewModal && <ViewArchiveModal handleClose={this.hideViewModal} />}
			</div>
		);
	}
}
ArchivedPaymentListing.propTypes = {
	archivedMandates: PropTypes.shape({
		fromAccount: PropTypes.shape({
			displayName: PropTypes.string.isRequired,
		}),
		display_name: PropTypes.string.isRequired,
		reference: PropTypes.string.isRequired,
	}),
	handleArchiveView: PropTypes.func.isRequired,
	content: PropTypes.shape(contentPropTypes),
	renderRetryComponent: PropTypes.func.isRequired,
	hasError: PropTypes.bool.isRequired,
	hasApiCallInProgress: PropTypes.bool.isRequired,
	sortByColumn: PropTypes.shape({}),
	setArchiveSortOrder: PropTypes.func,
	mandateArchivePage: PropTypes.number.isRequired,
	mandateArchivePageTotal: PropTypes.number.isRequired,
	persistSortOrder: PropTypes.func.isRequired,
};
export const connectWrapper = connect(mapState, mapDispatch)(ArchivedPaymentListing);
export default withContent({ content })(connectWrapper);
